import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M4.5 1H9.79297L13.5 4.70703V14C13.5 14.4229 13.3946 14.6483 13.2715 14.7715C13.1483 14.8946 12.9229 15 12.5 15H4.5C4.07707 15 3.85168 14.8946 3.72852 14.7715C3.60536 14.6483 3.5 14.4229 3.5 14V2C3.5 1.57707 3.60536 1.35168 3.72852 1.22852C3.85168 1.10536 4.07707 1 4.5 1Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10 0.5V3.7C10 4.23333 10.2667 4.5 10.8 4.5H14L10 0.5Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 8,
					width: 11.5,
					height: 6,
					rx: 1,
					fill: "#8C5EAE"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.22636 9.22727V12.5H2.53442V9.22727H3.22636Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.88565 9.22727H4.73899L5.64027 11.4261H5.67862L6.5799 9.22727H7.43324V12.5H6.76207V10.3698H6.73491L5.88796 12.484H5.43093L4.58399 10.3619H4.55682V12.5H3.88565V9.22727Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.2634 10.2852C10.2411 10.2074 10.2096 10.1387 10.1691 10.079C10.1287 10.0183 10.0791 9.96715 10.0205 9.9256C9.963 9.88299 9.89695 9.85049 9.82238 9.82812C9.74887 9.80575 9.66737 9.79456 9.57788 9.79456C9.41062 9.79456 9.26361 9.83611 9.13683 9.91921C9.01112 10.0023 8.91311 10.1232 8.8428 10.282C8.77248 10.4396 8.73733 10.6325 8.73733 10.8604C8.73733 11.0884 8.77195 11.2823 8.8412 11.4421C8.91045 11.6019 9.00846 11.7239 9.13523 11.8081C9.26201 11.8912 9.41169 11.9327 9.58427 11.9327C9.74088 11.9327 9.87458 11.905 9.98538 11.8496C10.0972 11.7931 10.1825 11.7138 10.2411 11.6115C10.3007 11.5092 10.3305 11.3883 10.3305 11.2488L10.4712 11.2695H9.62742V10.7486H10.9969V11.1609C10.9969 11.4485 10.9362 11.6957 10.8147 11.9023C10.6933 12.108 10.526 12.2667 10.313 12.3785C10.0999 12.4893 9.85594 12.5447 9.58108 12.5447C9.27426 12.5447 9.00473 12.4771 8.77248 12.3418C8.54024 12.2054 8.35913 12.0121 8.22916 11.7617C8.10025 11.5103 8.0358 11.212 8.0358 10.8668C8.0358 10.6016 8.07415 10.3651 8.15086 10.1573C8.22863 9.94851 8.33729 9.77166 8.47685 9.62677C8.61641 9.48189 8.77888 9.37162 8.96425 9.29598C9.14962 9.22035 9.35043 9.18253 9.5667 9.18253C9.75207 9.18253 9.92465 9.20969 10.0845 9.26402C10.2443 9.31729 10.3859 9.39293 10.5095 9.49094C10.6342 9.58895 10.7359 9.70561 10.8147 9.84091C10.8936 9.97514 10.9442 10.1232 10.9666 10.2852H10.2634Z",
					fill: "white"
				})
			]
		}),
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M6 1.5H14.793L19.5 6.20703V21C19.5 21.5896 19.353 21.94 19.1465 22.1465C18.94 22.353 18.5896 22.5 18 22.5H6C5.41041 22.5 5.06001 22.353 4.85352 22.1465C4.64702 21.94 4.5 21.5896 4.5 21V3C4.5 2.41041 4.64702 2.06001 4.85352 1.85352C5.06001 1.64702 5.41041 1.5 6 1.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15 1V5C15 5.66667 15.3333 6 16 6H20L15 1Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 12,
					width: 16,
					height: 8,
					rx: 1.5,
					fill: "#8C5EAE"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.30186 14.1363V18.5H3.37927V14.1363H4.30186Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.18091 14.1363H6.3187L7.5204 17.0682H7.57154L8.77324 14.1363H9.91103V18.5H9.01614V15.6598H8.97992L7.85066 18.4787H7.24128L6.11202 15.6491H6.0758V18.5H5.18091V14.1363Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.6846 15.5469C13.6548 15.4432 13.6129 15.3515 13.5589 15.272C13.5049 15.191 13.4389 15.1229 13.3607 15.0675C13.284 15.0106 13.196 14.9673 13.0965 14.9375C12.9985 14.9077 12.8899 14.8927 12.7706 14.8927C12.5475 14.8927 12.3515 14.9481 12.1825 15.0589C12.0149 15.1697 11.8842 15.331 11.7904 15.5426C11.6967 15.7528 11.6498 16.0099 11.6498 16.3139C11.6498 16.6179 11.696 16.8764 11.7883 17.0895C11.8806 17.3025 12.0113 17.4652 12.1804 17.5774C12.3494 17.6882 12.549 17.7436 12.7791 17.7436C12.9879 17.7436 13.1661 17.7067 13.3139 17.6328C13.463 17.5575 13.5767 17.4517 13.6548 17.3153C13.7343 17.179 13.7741 17.0177 13.7741 16.8317L13.9616 16.8594H12.8366V16.1648H14.6626V16.7145C14.6626 17.098 14.5816 17.4275 14.4197 17.7031C14.2578 17.9773 14.0348 18.1889 13.7507 18.3381C13.4666 18.4858 13.1413 18.5596 12.7748 18.5596C12.3657 18.5596 12.0063 18.4694 11.6967 18.289C11.387 18.1072 11.1456 17.8494 10.9723 17.5156C10.8004 17.1804 10.7144 16.7827 10.7144 16.3224C10.7144 15.9687 10.7656 15.6534 10.8679 15.3764C10.9715 15.098 11.1164 14.8622 11.3025 14.669C11.4886 14.4758 11.7052 14.3288 11.9524 14.228C12.1995 14.1271 12.4673 14.0767 12.7556 14.0767C13.0028 14.0767 13.2329 14.1129 13.446 14.1854C13.659 14.2564 13.848 14.3572 14.0127 14.4879C14.1789 14.6186 14.3146 14.7741 14.4197 14.9545C14.5248 15.1335 14.5923 15.331 14.6221 15.5469H13.6846Z",
					fill: "white"
				})
			]
		}),
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 40 40",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M10 2.5H24.793L32.5 10.207V35C32.5 35.9229 32.2696 36.5233 31.8965 36.8965C31.5233 37.2696 30.9229 37.5 30 37.5H10C9.07707 37.5 8.47668 37.2696 8.10352 36.8965C7.73036 36.5233 7.5 35.9229 7.5 35V5C7.5 4.07707 7.73036 3.47668 8.10352 3.10352C8.47668 2.73036 9.07707 2.5 10 2.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25 2V9C25 9.66667 25.3333 10 26 10H33L25 2Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 3,
					y: 21,
					width: 24,
					height: 13,
					rx: 2,
					fill: "#8C5EAE"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.95279 24.4545V31H6.56891V24.4545H7.95279Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.27137 24.4545H10.978L12.7806 28.8523H12.8573L14.6599 24.4545H16.3665V31H15.0242V26.7397H14.9699L13.276 30.968H12.3619L10.668 26.7237H10.6137V31H9.27137V24.4545Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.0269 26.5703C21.9822 26.4148 21.9193 26.2773 21.8384 26.158C21.7574 26.0366 21.6583 25.9343 21.5411 25.8512C21.4261 25.766 21.294 25.701 21.1448 25.6562C20.9978 25.6115 20.8348 25.5891 20.6558 25.5891C20.3213 25.5891 20.0273 25.6722 19.7737 25.8384C19.5223 26.0046 19.3263 26.2464 19.1857 26.5639C19.045 26.8793 18.9747 27.2649 18.9747 27.7209C18.9747 28.1768 19.044 28.5646 19.1825 28.8842C19.321 29.2038 19.517 29.4478 19.7705 29.6161C20.0241 29.7823 20.3234 29.8654 20.6686 29.8654C20.9818 29.8654 21.2492 29.81 21.4708 29.6992C21.6945 29.5863 21.865 29.4276 21.9822 29.223C22.1015 29.0185 22.1612 28.7766 22.1612 28.4975L22.4424 28.5391H20.7549V27.4972H23.4939V28.3217C23.4939 28.897 23.3724 29.3913 23.1295 29.8047C22.8867 30.2159 22.5521 30.5334 22.126 30.7571C21.6999 30.9787 21.2119 31.0895 20.6622 31.0895C20.0486 31.0895 19.5095 30.9542 19.045 30.6836C18.5805 30.4109 18.2183 30.0241 17.9584 29.5234C17.7006 29.0206 17.5717 28.424 17.5717 27.7337C17.5717 27.2031 17.6484 26.7301 17.8018 26.3146C17.9573 25.897 18.1746 25.5433 18.4538 25.2535C18.7329 24.9638 19.0578 24.7432 19.4286 24.592C19.7993 24.4407 20.2009 24.3651 20.6335 24.3651C21.0042 24.3651 21.3494 24.4194 21.669 24.528C21.9886 24.6346 22.2719 24.7859 22.5191 24.9819C22.7684 25.1779 22.9719 25.4112 23.1295 25.6818C23.2872 25.9503 23.3884 26.2464 23.4332 26.5703H22.0269Z",
					fill: "white"
				})
			]
		}),
		width: 40,
		height: 40
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as FileImageIcon };
